import { render, staticRenderFns } from "./historialIngresos.vue?vue&type=template&id=49d57ca0&scoped=true"
import script from "./historialIngresos.vue?vue&type=script&lang=js"
export * from "./historialIngresos.vue?vue&type=script&lang=js"
import style0 from "./historialIngresos.vue?vue&type=style&index=0&id=49d57ca0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d57ca0",
  null
  
)

export default component.exports